module.exports = __webpack_public_path__ + "static/media/aryane.9f5676cd.jpg";